import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHeader, Pill, dOnly } from "./_shared";

const TABS = [
  { k: "today", l: "Hoje" },
  { k: "tomorrow", l: "Amanhã" },
  { k: "next7", l: "Próx. 7 dias" },
  { k: "next30", l: "Próx. 30 dias" },
  { k: "month", l: "Mês atual" },
];

export default function AdminBirthdays() {
  const [tab, setTab] = useState("today");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/admin/birthdays?range=${tab}`).then(r => setRows(r.data.rows)); }, [tab]);

  return (
    <div className="p-3 sm:p-6 lg:p-8" data-testid="admin-birthdays">
      <PageHeader title="🎂 Aniversariantes" subtitle="Base de usuários do Hermes"
        right={
          <div className="flex bg-[#0f1524] border border-white/5 rounded-xl p-1">
            {TABS.map(t => (
              <button key={t.k} onClick={()=>setTab(t.k)}
                className={`px-3 py-1.5 rounded-lg text-xs ${tab === t.k ? "bg-[#d4a24c] text-black font-semibold" : "text-slate-300 hover:bg-white/5"}`}
                data-testid={`admin-bday-tab-${t.k}`}
              >{t.l}</button>
            ))}
          </div>
        }
      />

      <Card testid="admin-birthdays-list">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-white/5">
              <th className="py-3 pr-4">Nome</th>
              <th className="py-3 pr-4">Data</th>
              <th className="py-3 pr-4">Idade</th>
              <th className="py-3 pr-4">Cidade / UF</th>
              <th className="py-3 pr-4">Plano</th>
              <th className="py-3 pr-4">Cartão</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan="6" className="py-8 text-center text-slate-500">Nenhum aniversariante no período</td></tr>}
            {rows.map(r => (
              <tr key={r.user_id} className="border-b border-white/5" data-testid={`admin-bday-row-${r.user_id}`}>
                <td className="py-3 pr-4">
                  <div className="text-slate-100">{r.treatment ? `${r.treatment} ` : ""}{r.name}</div>
                  <div className="text-[11px] text-slate-500">{r.email}</div>
                </td>
                <td className="py-3 pr-4 text-slate-300">{dOnly(r.birth_date)}</td>
                <td className="py-3 pr-4 text-slate-300">{r.age ?? "—"}</td>
                <td className="py-3 pr-4 text-slate-300">{r.city || "—"} {r.state_code ? `/ ${r.state_code}` : ""}</td>
                <td className="py-3 pr-4"><Pill tone={r.plan === "free" ? "slate" : "gold"}>{r.plan}</Pill></td>
                <td className="py-3 pr-4"><Pill tone="slate">A ENVIAR</Pill></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <div className="mt-4 text-xs text-slate-500">
        Envio automático de cartões de aniversário (Nano Banana) será ativado em uma próxima fase — hoje mostramos apenas a base.
      </div>
    </div>
  );
}
